"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/INFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_111)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_111`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V8H-6V0Z",
					fill: "#FF9933"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 8H30V16H-6V8Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 16H30V24H-6V16Z",
					fill: "#138808"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12 14.4C13.3255 14.4 14.4 13.3255 14.4 12C14.4 10.6745 13.3255 9.59998 12 9.59998C10.6745 9.59998 9.59998 10.6745 9.59998 12C9.59998 13.3255 10.6745 14.4 12 14.4Z",
					stroke: "#000080",
					strokeWidth: .280702
				}),
				/* @__PURE__ */ n("path", {
					d: "M12 12.24C12.1326 12.24 12.24 12.1326 12.24 12C12.24 11.8675 12.1326 11.76 12 11.76C11.8675 11.76 11.76 11.8675 11.76 12C11.76 12.1326 11.8675 12.24 12 12.24Z",
					fill: "#000080"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.6175 9.69535L11.3824 14.3046L12.6175 9.69535ZM12.6175 9.69535L11.3824 14.3046L12.6175 9.69535ZM13.193 9.93366L10.807 14.0663L13.193 9.93366ZM13.6871 10.3128L10.3128 13.6871L13.6871 10.3128ZM14.0663 10.807L9.93366 13.193L14.0663 10.807ZM14.3046 11.3824L9.69535 12.6175L14.3046 11.3824ZM14.3859 12H9.61401H14.3859ZM14.3046 12.6175L9.69535 11.3824L14.3046 12.6175ZM14.0663 13.193L9.93366 10.807L14.0663 13.193ZM13.6871 13.6871L10.3128 10.3128L13.6871 13.6871ZM13.193 14.0663L10.807 9.93366L13.193 14.0663ZM12.6175 14.3046L11.3824 9.69535L12.6175 14.3046ZM12 14.3859V9.61401V14.3859ZM12.6175 9.69535L11.3824 14.3046L12.6175 9.69535ZM13.193 9.93366L10.807 14.0663L13.193 9.93366ZM13.6871 10.3128L10.3128 13.6871L13.6871 10.3128ZM14.0663 10.807L9.93366 13.193L14.0663 10.807ZM14.3046 11.3824L9.69535 12.6175L14.3046 11.3824ZM14.3859 12H9.61401H14.3859ZM14.3046 12.6175L9.69535 11.3824L14.3046 12.6175ZM14.0663 13.193L9.93366 10.807L14.0663 13.193ZM13.6871 13.6871L10.3128 10.3128L13.6871 13.6871ZM13.193 14.0663L10.807 9.93366L13.193 14.0663ZM12.6175 14.3046L11.3824 9.69535L12.6175 14.3046Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.6175 9.69535L11.3824 14.3046M13.193 9.93366L10.807 14.0663M13.6871 10.3128L10.3128 13.6871M14.0663 10.807L9.93366 13.193M14.3046 11.3824L9.69535 12.6175M14.3859 12H9.61401M14.3046 12.6175L9.69535 11.3824M14.0663 13.193L9.93366 10.807M13.6871 13.6871L10.3128 10.3128M13.193 14.0663L10.807 9.93366M12.6175 14.3046L11.3824 9.69535M12 14.3859V9.61401",
					stroke: "#000080",
					strokeWidth: .140351
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_111`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as INFlag };
